import { render } from "./SaleRank.vue?vue&type=template&id=f1fe742c"
import script from "./SaleRank.vue?vue&type=script&lang=js"
export * from "./SaleRank.vue?vue&type=script&lang=js"

import "./SaleRank.vue?vue&type=style&index=0&id=f1fe742c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__